var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlatfixfusion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 202.7 39.7",
    style: {
      enableBackground: "new 0 0 202.7 39.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F8AD22;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#262B5B;}\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:0.709;stroke-miterlimit:10;}\n\t.st4{fill:#F18423;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "141.6,1.1 141.6,26.5 141.6,27 141.2,27.3 130.3,38.3 189.8,38.3 201.6,26.5 201.6,1.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "150.5,19.2 148.6,19.2 148.6,9.1 153.7,9.1 153.7,10.8 150.5,10.8 150.5,13.4 153.5,13.4 153.5,15.2  150.5,15.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.9,9.1v6.6c0,0.7-0.1,1.4-0.4,2c-0.3,0.6-0.7,1-1.3,1.3c-0.6,0.3-1.2,0.5-2,0.5c-1.1,0-2-0.3-2.7-1 c-0.6-0.7-0.9-1.6-0.9-2.7V9.1h1.9v6.2c0,0.8,0.1,1.4,0.4,1.7c0.3,0.4,0.7,0.5,1.4,0.5c0.6,0,1.1-0.2,1.3-0.6 c0.3-0.4,0.4-0.9,0.4-1.7V9.1H162.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.5,16.4c0,0.9-0.3,1.6-0.9,2.2c-0.6,0.5-1.4,0.8-2.4,0.8c-1,0-1.8-0.2-2.5-0.6v-2 c0.6,0.3,1.1,0.5,1.5,0.6c0.4,0.1,0.8,0.2,1.1,0.2c0.4,0,0.7-0.1,1-0.3c0.2-0.2,0.3-0.4,0.3-0.8c0-0.2,0-0.4-0.1-0.5 c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.6-0.4-1.2-0.7c-0.5-0.3-1-0.6-1.2-0.8c-0.3-0.3-0.5-0.6-0.7-0.9c-0.2-0.4-0.2-0.8-0.2-1.2 c0-0.9,0.3-1.6,0.8-2.1c0.5-0.5,1.3-0.8,2.2-0.8c0.5,0,0.9,0.1,1.3,0.2c0.4,0.1,0.9,0.3,1.3,0.5l-0.6,1.7 c-0.5-0.2-0.9-0.4-1.2-0.5c-0.3-0.1-0.6-0.1-0.9-0.1c-0.4,0-0.6,0.1-0.8,0.3c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.2,0,0.4,0.1,0.5 c0.1,0.1,0.2,0.3,0.4,0.4c0.2,0.1,0.6,0.4,1.2,0.7c0.8,0.5,1.4,0.9,1.7,1.4C170.4,15.2,170.5,15.7,170.5,16.4"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 172.3,
    y: 9.1,
    className: "st1",
    width: 1.9,
    height: 10.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.2,14.1c0,1.1,0.2,2,0.6,2.6c0.4,0.6,0.9,0.9,1.7,0.9c1.5,0,2.3-1.1,2.3-3.4c0-2.3-0.8-3.4-2.3-3.4 c-0.8,0-1.3,0.3-1.7,0.9C178.4,12.1,178.2,13,178.2,14.1 M184.8,14.1c0,1.7-0.4,3-1.1,3.9c-0.7,0.9-1.8,1.4-3.1,1.4 s-2.4-0.5-3.1-1.4c-0.7-0.9-1.1-2.2-1.1-3.9c0-1.7,0.4-3,1.1-3.9c0.7-0.9,1.8-1.3,3.2-1.3c1.4,0,2.4,0.4,3.1,1.3 C184.4,11.1,184.8,12.4,184.8,14.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M194.7,19.2h-2.4l-3.9-7.7h-0.1c0.1,1.4,0.1,2.3,0.1,2.9v4.8h-1.7V9.1h2.4l3.9,7.6h0 c-0.1-1.3-0.1-2.2-0.1-2.8V9.1h1.7V19.2z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1.1,1.1 1.1,38.3 1.1,38.6 1.5,38.6 128.6,38.6 128.7,38.6 128.8,38.5 140.6,26.7 140.7,26.6  140.7,26.5 140.7,1.1 140.7,0.8 140.4,0.8 1.5,0.8 1.1,0.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "1.1,1.1 1.1,38.3 1.1,38.6 1.5,38.6 128.6,38.6 128.7,38.6 128.8,38.5 140.6,26.7 140.7,26.6  140.7,26.5 140.7,1.1 140.7,0.8 140.4,0.8 1.5,0.8 1.1,0.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "27.6,11.8 27.6,15.5 18.4,15.5 16.6,17.3 22.1,17.3 22.1,21 16.6,21 16.6,26.5 11.1,26.5 11.1,17.3  16.6,11.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59,15.5h-3.7l-1.8,1.8H59V15.5z M53.5,11.8h11v14.7H59V21h-5.5v5.5H48v-9.2L53.5,11.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "83.1,11.8 83.1,15.5 77.6,15.5 77.6,26.5 72.1,26.5 72.1,15.5 66.4,15.5 66.4,11.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.5,11.8 101.5,15.5 92.3,15.5 90.5,17.3 96,17.3 96,21 90.5,21 90.5,26.5 85,26.5 85,17.3  90.5,11.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.6,
    y: 11.8,
    className: "st4",
    width: 5.5,
    height: 14.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "122.4,11.8 128,11.8 128,17.3 126.1,19.2 128,21 128,26.5 122.4,26.5 122.4,22.9 120.6,21 118.8,21  116.9,22.9 116.9,26.5 111.4,26.5 111.4,21 113.3,19.2 111.4,17.3 111.4,11.8 116.9,11.8 116.9,15.5 118.8,17.3 120.6,17.3  122.4,15.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "46.1,26.5 34.8,26.5 29.6,21 29.6,11.8 34.8,11.8 34.8,21 36.6,22.9 46.1,22.9  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlatfixfusion);
export default __webpack_public_path__ + "static/media/flatfixfusion.adfe3dd1b049df8974fee66d80cbbe0b.svg";
export { ForwardRef as ReactComponent };